document.addEventListener("DOMContentLoaded", () => {
    //var nearestDateTime = new Date((new Date()).getTime() + 5 * 60000);
    //tempusDominus.extend(tempusDominus.plugins.moment_parse, 'DD.MM.yyyy HH:mm');
    document.querySelectorAll('.datetimepicker').forEach(dtEl => {
        let picker = new tempusDominus.TempusDominus(dtEl, {
            // https://getdatepicker.com/6/options.html
            display: {
                viewMode: 'calendar',
                sideBySide: true,
                components: {
                    decades: false,
                    year: true,
                    month: true,
                    date: true,
                    hours: true,
                    minutes: true,
                    seconds: false
                }
            },
            restrictions: {
                minDate: new tempusDominus.DateTime(new Date())
            },
            stepping: 5,
            useCurrent: true,
            //defaultDate: nearestDateTime,
            localization: {
                startOfTheWeek: 1,
                locale: 'ru',
                hourCycle: 'h24',
                format: 'dd.MM.yyyy HH:mm'
            }
        });
    });

    document.querySelectorAll('.datepicker').forEach(dtEl => {
        new tempusDominus.TempusDominus(dtEl, {
            display: {
                components: {
                    year: true,
                    month: true,
                    date: true,
                    hours: false,
                    minutes: false,
                    seconds: false,
                }
            },
            localization: {
                startOfTheWeek: 1,
                locale: 'ru',
                hourCycle: 'h24',
                format: 'dd.MM.yyyy HH:mm'
            }
        });
    });

    document.querySelectorAll('.timepicker').forEach(dtEl => {
        new tempusDominus.TempusDominus(dtEl, {
            display: {
                components: {
                    year: false,
                    month: false,
                    date: false,
                    hours: true,
                    minutes: true,
                    seconds: false,
                    useTwentyfourHour: true
                }
            },
            stepping: 5,
            useCurrent: true,
            localization: {
                startOfTheWeek: 1,
                locale: 'ru',
                hourCycle: 'h24',
                format: 'dd.MM.yyyy HH:mm'
            }
        });
    });
    let clientTimeZone = -(new Date().getTimezoneOffset() / 60);

    document.querySelectorAll('.user-timezone').forEach(c => { c.value = clientTimeZone; });

    document.querySelectorAll('.external-link').forEach(c => {
        c.innerHTML += '&nbsp;<i class="fa fa-external-link small"></i>';
    });
});


function displayLocalDatetime(displayElementId, timestamp) {
    let d = new Date(timestamp * 1000);
    console.log('toLocalString: ', d.toLocaleString());
    document.getElementById(displayElementId).innerText = d.toLocaleString();
}
